<ng-template #tableTemplate>
    <n-data-table id="delete-client-cifs-share-table"
        style="height: 2rem;"
        [columnDefs]="tableColumnDefs"
        [data]="dataList">
    </n-data-table>
</ng-template>

